import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { ActivityLog } from '../../../../stores/activityLogStore';

interface UserStatsChartProps {
  logs: ActivityLog[];
}

export default function UserStatsChart({ logs }: UserStatsChartProps) {
  // Process logs to get daily stats
  const getDailyStats = () => {
    const last7Days = Array.from({ length: 7 }, (_, i) => {
      const date = new Date();
      date.setDate(date.getDate() - i);
      return date.toISOString().split('T')[0];
    }).reverse();

    return last7Days.map(date => {
      const dayLogs = logs.filter(log => log.timestamp.startsWith(date));
      return {
        date: new Date(date).toLocaleDateString('en-US', { weekday: 'short' }),
        logins: dayLogs.filter(log => log.action === 'login').length,
        signups: dayLogs.filter(log => log.action === 'signup').length,
        activity: dayLogs.length
      };
    });
  };

  const data = getDailyStats();

  return (
    <div className="bg-white p-6 rounded-lg border border-gray-100">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">User Activity (Last 7 Days)</h3>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="logins" fill="#4F46E5" name="Logins" />
            <Bar dataKey="signups" fill="#10B981" name="Signups" />
            <Bar dataKey="activity" fill="#6366F1" name="Total Activity" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}